import { UpdateReason } from "@/sharedTypes";
import { baseApi } from "../baseApi";

const updateReasonTag = "UpdateReason";

export const updateReasonApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaginatedUpdateReasons: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        
        if (params) {
           const { filters, pagination } = params as any;
           
           if (filters) {
               Object.entries(filters).forEach(([key, value]) => {
                   if (value !== undefined && value !== null && value !== "") {
                       searchParams.append(key, String(value));
                   }
               });
           }
           
           if (pagination) {
               Object.entries(pagination).forEach(([key, value]) => {
                   if (value !== undefined && value !== null) {
                       searchParams.append(key, String(value));
                   }
               });
           }
        }
        
        const queryString = searchParams.toString();
        return `/gw/update-reasons${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [updateReasonTag],
    }),
    createUpdateReason: builder.mutation({
      query: (payload: UpdateReason) => ({
        url: "/gw/update-reasons",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [updateReasonTag],
    }),
    updateUpdateReason: builder.mutation({
      query: ({ update_reason_id, ...payload }: UpdateReason) => ({
        url: `/gw/update-reasons/${update_reason_id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: [updateReasonTag],
    }),
    deleteUpdateReason: builder.mutation({
      query: (id: number) => ({
        url: `/gw/update-reasons/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [updateReasonTag],
    }),
    restoreUpdateReason: builder.mutation({
      query: (id: number) => ({
        url: `/gw/update-reasons/${id}/restore`,
        method: "PUT",
      }),
      invalidatesTags: [updateReasonTag],
    }),
    hardDeleteUpdateReason: builder.mutation({
      query: (id: number) => ({
        url: `/gw/update-reasons/${id}/permanent`,
        method: "DELETE",
      }),
      invalidatesTags: [updateReasonTag],
    }),
  }),
});

export const {
  useGetPaginatedUpdateReasonsQuery,
  useCreateUpdateReasonMutation,
  useUpdateUpdateReasonMutation,
  useDeleteUpdateReasonMutation,
  useRestoreUpdateReasonMutation,
  useHardDeleteUpdateReasonMutation,
} = updateReasonApi;
